import { Route, Routes } from "react-router-dom";
import { OSCI0204001S } from "@/tz/go/egaz/osci/lpco/hscd/itm/OSCI0204001S";
import { OSCI0204002Q } from "@/tz/go/egaz/osci/lpco/hscd/itm/OSCI0204002Q";
import { OSCI0204003S } from "@/tz/go/egaz/osci/lpco/hscd/itm/OSCI0204003S";
import { OSCI0204004S } from "@/tz/go/egaz/osci/lpco/hscd/itm/OSCI0204004S";
/* Verification */
import { OSCI0204005S } from "@/tz/go/egaz/osci/lpco/hscd/ctgr/OSCI0204005S";
import { OSCI0204006Q } from "@/tz/go/egaz/osci/lpco/hscd/ctgr/OSCI0204006Q";
import { OSCI0204007S } from "@/tz/go/egaz/osci/lpco/hscd/ctgr/OSCI0204007S";
import { OSCI0204008S } from "@/tz/go/egaz/osci/lpco/hscd/ctgr/OSCI0204008S";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 * TODO URL의 'key' 를 실제 ID로 변경 하세요.
 * TODO 위의 한글 주석은 마지막에 전부 삭제하세요.
 */

export const OsciHsCdRouter = () => {
    return (
        <Routes>
            {/*  !== HS Code 신청 / 조회 ==! */}
            <Route path="itm/osci0204001s" element={<OSCI0204001S />} />
            <Route path="itm/osci0204001s/:hsAppId" element={<OSCI0204001S />} />
            <Route path="itm/osci0204002q" element={<OSCI0204002Q />} />
            <Route path="itm/osci0204003s/:hsAppId" element={<OSCI0204003S />} />
            <Route path="itm/osci0204004s/:hsAppId" element={<OSCI0204004S />} />

            <Route path="ctgr/osci0204005s" element={<OSCI0204005S />} />
            <Route path="ctgr/osci0204006q" element={<OSCI0204006Q />} />
            <Route path="ctgr/osci0204007s/:hsCtgrId" element={<OSCI0204007S />} />
            <Route path="ctgr/osci0204008s/:hsCtgrId" element={<OSCI0204008S />} />
        </Routes>
    );
};
